import "./ZoneAttendanceDashboard.css";
import React, { useState, useEffect } from "react";
import { format, isSameDay } from "date-fns";
import Select from "react-select";
import {
  zoneAttendaceWithDistrict,
  zoneAttendaceWithoutDistrict,
  getPresentEmployeesZone,
  getAbsentEmployeesZone,
  getNotInLocationEmployeesZone,
} from "../../../../services/dashboard";
import { getDistrictByZoneId } from "../../../../services/monthlyAttendanceService";

const ZoneDashboard = () => {
  const [isFocused, setIsFocused] = useState({ district: false });
  const today = new Date();
  const [districtOptions, setDistrictOptions] = useState([]);
  const [district, setDistrict] = useState("");
  const [districtId, setDistrictId] = useState("");
  const [sameDayAttendance, setSameDayAttendance] = useState(null);
  const employeeUniqueId = localStorage.getItem("employeeUniqueIdLogin");
  const zoneName = localStorage.getItem("zoneName");
  const zoneId = localStorage.getItem("zoneId");
  const [errors, setErrors] = useState({});
  const [differenceDayAttendace, setDifferenceDayAttendance] = useState({});
  const [userData, setUSerData] = useState([]);
  const [startDate, setStartDate] = useState(today);
  const [displayMode, setDisplayMode] = useState("all");
  const [filteredRecords, setFilteredRecords] = useState([]);
  const [filterLoading, setFilterLoading] = useState(false);
  const [filterError, setFilterError] = useState(null);
  const [filterTitle, setFilterTitle] = useState("");

  useEffect(() => {
    const fetchAttendance = async () => {
      try {
        if (district && district !== "ALL") {
          const data = await zoneAttendaceWithDistrict(district, today);
          setSameDayAttendance(data);
          setFilteredRecords(data?.records || []);
          setDisplayMode("all");
          setFilterTitle("");
        } else {
          const data = await zoneAttendaceWithoutDistrict(zoneId, today);
          setDifferenceDayAttendance(data);
          setSameDayAttendance(null);
        }
      } catch (e) {
        console.error(e);
      } finally {
        setFilterLoading(false);
      }
    };
    fetchAttendance();
  }, [district, zoneId]);

  const getDistrictByZones = async () => {
    const data = await getDistrictByZoneId(zoneId);

    if (data?.districts) {
      const list = data.districts.map(d => ({
        value: d.districtId,
        label: d.districtName,
      }));

      // 👇 Add "All Districts" on top
      const options = [
        { value: "ALL", label: "All Districts" },
        ...list
      ];

      setDistrictOptions(options);
    }
  };


  useEffect(() => {
    if (zoneId) {
      getDistrictByZones();
    }
  }, [zoneId]);

  const fetchAndShow = async (apiFn, mode, title) => {
    setFilterLoading(true);
    setFilterError(null);
    try {
      let data;

      if (district && district !== "ALL") {
        // Pass: stateId, date, district
        data = await apiFn(zoneId, today, district);
      } else {
        // Pass: stateId, date, NO district
        data = await apiFn(zoneId, today, null);
      }
      setFilteredRecords(Array.isArray(data.records) ? data.records : []);
      setDisplayMode(mode);
      setFilterTitle(title);
    } catch (e) {
      setFilterError("Failed to load data");
      setFilteredRecords([]);
    } finally {
      setFilterLoading(false);
    }
  };

  const showAllEmployees = async () => {
    setFilterLoading(true);
    setFilterError(null);

    try {
      if (district) {
        // ⬅ FIX: Load district employee list again
        const data = await zoneAttendaceWithDistrict(district, today);
        setFilteredRecords(data.records || []);
        setDisplayMode("all");
        setFilterTitle("");
      } else {
        // zone level
        const data = await zoneAttendaceWithoutDistrict(zoneId, today);
        setFilteredRecords(data.records || []);
        setDisplayMode("all");
      }
    } catch (e) {
      setFilterError("Failed to load data");
      setFilteredRecords([]);
    } finally {
      setFilterLoading(false);
    }
  };


  const showPresent = () => fetchAndShow(district ? getPresentEmployeesZone : getPresentEmployeesZone, "present", `Present Employees – ${format(today, "dd-MM-yyyy")}`);
  const showAbsent = () => fetchAndShow(district ? getAbsentEmployeesZone : getAbsentEmployeesZone, "absent", `Absent Employees – ${format(today, "dd-MM-yyyy")}`);
  const showNotInLocation = () => fetchAndShow(district ? getNotInLocationEmployeesZone : getNotInLocationEmployeesZone, "notInLocation", `Not-in-Location – ${format(today, "dd-MM-yyyy")}`);

  const handleInputChange = (selectedOption, field) => {
    const value = selectedOption ? selectedOption.value : "";
    switch (field) {
      case "district":
        if (field === "district") {
          // ⭐ If "ALL", treat like no district selected
          if (value === "ALL") {
            setDistrict("ALL");          // Reset district
            setDistrictId("");
          } else {
            setDistrict(value);
            setDistrictId(value);
          }
        }
        break;
          default:
        break;
    }
    setErrors(prev => ({ ...prev, [field]: null }));
  };

  const renderRows = () => {
    if (filterLoading) return <tr><td colSpan={10} className="text-center">Loading…</td></tr>;
    if (filterError) return <tr><td colSpan={10} className="text-center text-danger">{filterError}</td></tr>;
    if (!filteredRecords.length) return <tr><td colSpan={10} className="text-center">No data</td></tr>;

    return filteredRecords.map((r, i) => (
      <tr key={i}>
        <td>{i + 1}</td>
        <td className="text-start">{r.employeeName ?? "-"}</td>
        <td>{r.designation ?? "-"}</td>
{/* ⭐ WorkLocation / Godown Logic */}
  <td>
    {r.isWorkLocation === true
      ? (r.workLocationName?.trim() || "-")
      : (r.godownName?.trim() || "-")}
  </td>        <td>{r.contactNumber ?? "-"}</td>
        <td>{r.attendanceStatus ?? "-"}</td>
        <td>{r.attendanceTime ?? "-"}</td>
        <td>
          {r.attendanceStatus === "Present" && (!r.remarks || r.remarks === "")
            ? "In the location"
            : r.remarks && r.attendanceStatus === "Present"
              ? "Not in the location"
              : "-"}
        </td>
        <td>{r.remarks ?? "-"}</td>
        <td>
          {r.selfieUrl ? (
            <a
              href={r.selfieUrl.startsWith("http") ? r.selfieUrl : `${process.env.REACT_APP_FILE_BASE_URL}/${r.selfieUrl}`}
              target="_blank"
              rel="noreferrer"
            >
              View
            </a>
          ) : "-"}
        </td>
      </tr>
    ));
  };

  return (
    <div className="apm-dashboard-page">
      <div className="apm-new-dashboard-dash">
        <div className="apm-current-month-date-dash">
          <h2>APM Dashboard - {zoneName}</h2>
        </div>
        <div className="d-flex justify-content-center align-items-center mt-2">
          <div className="mb-0"><label>District : </label></div>
          <div style={{ minWidth: "200px" }}>
            <Select
              name="district"
              options={districtOptions}
              value={districtOptions.find(opt => opt.value === district) || null}
              onChange={option => handleInputChange(option, "district")}
              onFocus={() => setIsFocused(prev => ({ ...prev, district: true }))}
              placeholder="Select District"
              isClearable
              className="w-100"
            />
          </div>
        </div>
        <div className="apm-current-month-dash">
          <div className="select-date-text-dash">
            <div className="month-text-dash">Attendance on : {format(today, "dd-MM-yyyy")}</div>
          </div>
          <div className="apm-content-data-for-month-dash">
            <div
              className={`apm-present-days-dash ${displayMode === "present" ? "active" : ""}`}
              onClick={showPresent}
              style={{ cursor: "pointer" }}
            >
              <div className="apm-data-user-values1">
                {district && district !== "ALL" ? sameDayAttendance?.presentCount ?? 0 : differenceDayAttendace?.totalPresent ?? 0}
              </div>
              <div className="apm-data-user-label">No of Present</div>
            </div>
            <div
              className={`apm-present-days-dash ${displayMode === "absent" ? "active" : ""}`}
              onClick={showAbsent}
              style={{ cursor: "pointer" }}
            >
              <div className="apm-data-user-values2">
                {district && district !== "ALL" ? sameDayAttendance?.absentCount ?? 0 : differenceDayAttendace?.totalAbsent ?? 0}
              </div>
              <div className="apm-data-user-label">No of Absent</div>
            </div>
            <div
              className={`apm-present-days-dash leave-card ${displayMode === "notInLocation" ? "active" : ""}`}
              onClick={showNotInLocation}
              style={{ cursor: "pointer" }}
            >
              <div className="apm-data-user-values3">
                {district && district !== "ALL" ? sameDayAttendance?.remarksCount ?? 0 : differenceDayAttendace?.totalNotInLocation ?? 0}
              </div>
              <div className="apm-data-user-label">Not in the location</div>
            </div>
            <div
              className="apm-present-days-dash leave-card"
            // className={`apm-present-days-dash leave-card ${displayMode === "all" ? "active" : ""}`}
            // onClick={showAllEmployees}
            // style={{ cursor: "pointer" }}
            >
              <div className="apm-data-user-values3">
                {district && district !== "ALL" ? sameDayAttendance?.totalEmployeeCount ?? 0 : differenceDayAttendace?.totalEmployees ?? 0}
              </div>
              <div className="apm-data-user-label">Total No of Employees</div>
            </div>
          </div>
        </div>
        <div className="d-flex align-items-center justify-content-between mt-3 mb-2">
          <h5 className="mb-0">{filterTitle}</h5>
          {displayMode !== "all" && (
            <button className="btn btn-sm btn-outline-primary" onClick={showAllEmployees}>
              Show All
            </button>
          )}
        </div>

        {((district && district !== "ALL") || displayMode !== "all") && (
          <div className="apm-table-for-emp">
            <table className="apm-table-dash">
              <thead className="apm-table-head-dash">
                <tr>
                  <th>S.No</th>
                  <th>Employee Name</th>
                  <th>Designation</th>
                  <th>Working Location</th>
                  <th>Mobile Number</th>
                  <th>Attendance Status</th>
                  <th>Attendance Time</th>
                  <th>Location Status</th>
                  <th>Remarks</th>
                  <th>Attendance Photo</th>
                </tr>
              </thead>
              <tbody className="table-body-dash">{renderRows()}</tbody>
            </table>
          </div>
        )}


        {((!district || district === "ALL") && displayMode === "all") && (
          <div className="itm-table-for-emp">
            <table className="mx-auto ms-4 me-4 my-4 d-block overflow-x-auto ">
              <thead className="itm-table-head-dash">
                <tr >
                  <th>S.No</th>
                  <th>District</th>
                  <th>No. of Employees Present</th>
                  <th>No. of Employees Absent</th>
                  <th>No. of Employees Not in the Location</th>
                  <th>No. of Total Employees</th>

                </tr>
              </thead>
              <tbody className="table-body-dash">
                {differenceDayAttendace?.districts?.length > 0 ? (
                  differenceDayAttendace.districts.map((dist, idx) => (
                    <tr key={dist.districtId ?? idx}>
                      <td>{idx + 1}</td>
                      <td className="text-start">{dist.districtName ?? "-"}</td>
                      <td>{dist.presentCount ?? "-"}</td>
                      <td>{dist.absentCount ?? "-"}</td>
                      <td>{dist.notInLocationCount ?? "-"}</td>
                      <td>{dist.totalEmployees ?? "-"}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={6} className="py-4">
                      {filterLoading ? "Loading…" : "No district data for the selected range."}
                    </td>
                  </tr>
                )}
              </tbody>

            </table>
          </div>
        )}

      </div>
    </div>
  );
};

export default ZoneDashboard;